export default __webpack_public_path__ + "static/media/amazed-pepe.a9deb0f0.gif";